export default __webpack_public_path__ + "static/media/Hauberk of the Huntmaster.a00cc11c.jpg";